import App from '@/layouts/App';
import { useLoginWithRedirect } from '@frontegg/nextjs';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@/components/Box';
import Image from '@/components/Image';
import LinkButton from '@/components/LinkButton';
import Typography from '@/components/Typography';

const useStyles = makeStyles((theme) => ({
  infoGraphic: {
    maxWidth: 380,
    margin: '20px 0',
    display: 'block',
  },
  button: {
    marginTop: 16,
  },
  link: {
    textDecoration: 'underline',
    color: theme.palette.text.primary,
  },
}));

const NotAuthenticated = () => {
  const classes = useStyles();
  const loginWithRedirect = useLoginWithRedirect();

  const handleLogin = () => {
    loginWithRedirect();
  };

  return (
    <App fullWidth pageId="not-authenticated" metaTitle="Not logged in">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Image
          className={classes.infoGraphic}
          src="/infographics/busy.png"
          alt="access denied image"
        />
        <Typography color="primary" variant="h4" align="center" gutterBottom>
          You are not authorised to view this page.
        </Typography>
        <Typography variant="body1" align="center" gutterBottom>
          Have an account? You can{' '}
          <LinkButton href="#" variant="naked" onClick={handleLogin}>
            login here
          </LinkButton>
          .
        </Typography>
      </Box>
    </App>
  );
};

export default NotAuthenticated;
